import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {
  CABINET_LABELS,
  SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS
} from "../../../../../constants";
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../../actions/sqftMenuFunctions";
import SQFTFeaturesHeader from "./commonParts/SQFTFeaturesHeader";
import SqftOptionsRelatedItemList from "./commonParts/SqftOptionsRelatedItemList";
import {addCabinetShapeToWorkspace} from "./helpers/addCabinetShapeToWorkspace";
//import SqftOptionsItemList from "./commonParts/SqftOptionsItemList";
//import SqftOptionsRelatedItems from "./part/SqftOptionsRelatedItems";
//import SqftOptionsBoxes from "./part/SqftOptionsBoxes";

const SqftNavigationBottom = (props) => {
  const {activeFeature} = props;
  const {menuOpened} = props;
  const expanded = menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.lower
    || menuOpened === SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS.lower_cabinet_boxes

  return (
    <div className={"content content--left side-level2" + (expanded ? " expanded" : "")}>
      <div className="side-level2__inner ">
        <SQFTFeaturesHeader headerTitle={ <FormattedMessage id={"sqft.navigation.submenu.lowerTitle"}/> }
                            partId={CABINET_LABELS.lower_cabinet_boxes}/>
        {expanded ?
          <SqftOptionsRelatedItemList activeFeature={activeFeature}
                                   partId={CABINET_LABELS.bottom_cabinet}
                                   shouldSortByWidth={true}
                                   itemClickCallback={(feature, parentFeature) => {
                                     addCabinetShapeToWorkspace(feature, parentFeature)}
                                   }
          />
        : null}
        {/*{*/}
        {/*  <SqftOptionsItemList activeFeature={activeFeature}*/}
        {/*                       partId={CABINET_LABELS.lower_cabinet_boxes}*/}
        {/*                       parentPartId={CABINET_LABELS.bottom_cabinet}*/}
        {/*                       expanded={expanded}*/}
        {/*                       shouldSortByWidth={true}*/}
        {/*                       itemClickCallback={(feature, parentFeature) => {*/}
        {/*                         cabinetWorkspace.cabinetShapes.addShape(feature, parentFeature)}*/}
        {/*                       }*/}
        {/*  />*/}
        {/*}*/}
        {
          // <SqftOptionsBoxes activeFeature={activeFeature}
          //                   partId={CABINET_LABELS.lower_cabinet_boxes}
          //                   itemClickCallback={(feature, parentFeature) => {
          //                     cabinetWorkspace.cabinetShapes.addShape(feature, parentFeature)}
          //                   }
          // />
        }
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {sqftFromFeature} = store.sqftState;
  return {
    menuOpened,
    activeFeature: sqftFromFeature ? sqftFromFeature.cartFeature : null
  };
};

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavigationBottom);
